import { render, staticRenderFns } from "./mendianshuju.vue?vue&type=template&id=15209ef0&scoped=true&"
import script from "./mendianshuju.vue?vue&type=script&lang=js&"
export * from "./mendianshuju.vue?vue&type=script&lang=js&"
import style0 from "./mendianshuju.vue?vue&type=style&index=0&id=15209ef0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15209ef0",
  null
  
)

export default component.exports